import React, { useState, lazy, Suspense } from 'react';
import { LandingContext } from './Components/Profile/LandingContext';
import apiService from './Common/Configurations/APIService';
import config from './Common/Configurations/APIConfig';
import { toast } from 'react-toastify';
import { Accordion, Form, Button, Nav } from 'react-bootstrap';

// 1. Import Mappers and Resolvers for ALL Templates
import { mapB2CTenantToLanding as mapT1, getB2CColors_T1 } from './Templates/Template_1/Colors_T1';
import { mapB2CTenantToLanding as mapT2, getB2CColors_T2 } from './Templates/Template_2/Colors_T2';
// import { mapB2CTenantToLanding as mapT3, getB2CColors_T3 } from './Templates/Template_3/Colors_T3';
import { mapB2CTenantToLanding as mapT4, getB2CColors_T4 } from './Templates/Template_4/Colors_T4';
// import { mapB2CTenantToLanding as mapT8, getB2CColors_T8 } from './Templates/Template_8/Colors_T8';
// import { mapB2CTenantToLanding as mapT21, getB2CColors_T21 } from './Templates/Template_21/Colors_T21';
import { mapB2CTenantToLanding as mapT31, getB2CColors_T31 } from './Templates/Template_31/Colors_T31'; // New Template Example
import { mapB2CTenantToLanding as mapT32, getB2CColors_T32 } from './Templates/Template_32/Colors_T32'; // New Template Example
import { mapB2CTenantToLanding as mapT33, getB2CColors_T33 } from './Templates/Template_33/Colors_T33'; // New Template Example
import { mapB2CTenantToLanding as mapT34, getB2CColors_T34 } from './Templates/Template_34/Colors_T34'; // New Template Example
import { mapB2CTenantToLanding as mapT35, getB2CColors_T35 } from './Templates/Template_35/Colors_T35';
import { mapB2CTenantToLanding as mapT36, getB2CColors_T36 } from './Templates/Template_36/Colors_T36'; // New Template Example
import { mapB2CTenantToLanding as mapT37, getB2CColors_T37 } from './Templates/Template_37/Colors_T37';
import { mapB2CTenantToLanding as mapT38, getB2CColors_T38 } from './Templates/Template_38/Colors_T38';
import { mapB2CTenantToLanding as mapT39, getB2CColors_T39 } from './Templates/Template_39/Colors_T39';
import { mapB2CTenantToLanding as mapT40, getB2CColors_T40 } from './Templates/Template_40/Colors_T40';
import { mapB2CTenantToLanding as mapT41, getB2CColors_T41 } from './Templates/Template_41/Colors_T41';
import { mapB2CTenantToLanding as mapT42, getB2CColors_T42 } from './Templates/Template_42/Colors_T42';
import { mapB2CTenantToLanding as mapT43, getB2CColors_T43 } from './Templates/Template_43/Colors_T43';
import { mapB2CTenantToLanding as mapT44, getB2CColors_T44 } from './Templates/Template_44/Colors_T44';
import { mapB2CTenantToLanding as mapT61, getB2CColors_T61 } from './Templates/Template_61/Colors_T61';
import { mapB2CTenantToLanding as mapT62, getB2CColors_T62 } from './Templates/Template_62/Colors_T62';
import { mapB2CTenantToLanding as mapT63, getB2CColors_T63 } from './Templates/Template_63/Colors_T63';
import { mapB2CTenantToLanding as mapT70, getB2CColors_T70 } from './Templates/Template_70/Colors_T70';

// 2. Lazy imports for Template Index Files
const Template_1 = lazy(() => import('./Templates/Template_1'));
const Template_2 = lazy(() => import('./Templates/Template_2'));
const Template_3 = lazy(() => import('./Templates/Template_3'));
const Template_4 = lazy(() => import('./Templates/Template_4'));
const Template_8 = lazy(() => import('./Templates/Template_8'));
const Template_21 = lazy(() => import('./Templates/Template_21'));
const Template_31 = lazy(() => import('./Templates/Template_31')); // New Template Example
const Template_32 = lazy(() => import('./Templates/Template_32')); // New Template Example
const Template_33 = lazy(() => import('./Templates/Template_33')); // New Template Example
const Template_34 = lazy(() => import('./Templates/Template_34')); // New Template Example
const Template_35 = lazy(() => import('./Templates/Template_35')); // New Template Example
const Template_36 = lazy(() => import('./Templates/Template_36')); // New Template Example
const Template_37 = lazy(() => import('./Templates/Template_37'));
const Template_38 = lazy(() => import('./Templates/Template_38'));
const Template_39 = lazy(() => import('./Templates/Template_39'));
const Template_40 = lazy(() => import('./Templates/Template_40'));
const Template_41 = lazy(() => import('./Templates/Template_41'));
const Template_42 = lazy(() => import('./Templates/Template_42'));
const Template_43 = lazy(() => import('./Templates/Template_43'));
const Template_44 = lazy(() => import('./Templates/Template_44'));
const Template_61 = lazy(() => import('./Templates/Template_61'));
const Template_62 = lazy(() => import('./Templates/Template_62'));
const Template_63 = lazy(() => import('./Templates/Template_63'));
const Template_70 = lazy(() => import('./Templates/Template_70'));

const templateMap = {
  Template_1,
  Template_2,
    Template_3,
  Template_4,
    Template_8,
    Template_21,
  Template_31,
  Template_32,
  Template_33,
    Template_34,
    Template_35,
    Template_36,
    Template_37,
    Template_38,
    Template_39,
    Template_40,
    Template_41,
    Template_42,
    Template_43,
    Template_44,
    Template_61,
    Template_62,
    Template_63,
    Template_70
};

const FONT_OPTIONS = [
    "Jost", "Cormorant Garamond", "Montserrat", "Poppins", 
    "Roboto", "Open Sans", "Playfair Display", "Lato", "Raleway"
];

const WebsiteVisualizer = ({ preloadedData, onBack }) => {
    // ⭐ Safety: If preloadedData is missing, this component will crash. 
    // We initialize workingData directly from the prop.
    const [workingData, setWorkingData] = useState(preloadedData);
    const [isSaving, setIsSaving] = useState(false);
    const [activeView, setActiveView] = useState('flights');

    if (!workingData) return <div className="p-5 text-center">No configuration data found.</div>;

    // Generic Update Handlers
    const updateSection = (section, key, value) => {
        setWorkingData(prev => ({
            ...prev,
            [section]: { ...prev[section], [key]: value }
        }));
    };

    const updateModuleHero = (module, key, value) => {
        setWorkingData(prev => ({
            ...prev,
            hero: {
                ...prev.hero,
                [module]: { ...(prev.hero[module] || {}), [key]: value }
            }
        }));
    };

    const handlePublish = async () => {
        setIsSaving(true);
        try {
            const formData = new FormData();
            formData.append("CompanyId", workingData.companyId);
            formData.append("BranchId", workingData.branchId);
            formData.append("UserId", workingData.userId);
            formData.append("TemplateId", workingData.templateId);
            formData.append("TemplateType", workingData.templateType);
            formData.append("TemplateReference", workingData.templateReference); // ⭐ Captured from Manager
            formData.append("Domain", workingData.domain);

            formData.append("CustomBrandingJson", JSON.stringify(workingData.branding));
            formData.append("StyleJson", JSON.stringify(workingData.theme));
            formData.append("TopBarJson", JSON.stringify(workingData.topBar));
            formData.append("HeaderJson", JSON.stringify(workingData.header));
            formData.append("HeroJson", JSON.stringify(workingData.hero));
            formData.append("FooterJson", JSON.stringify(workingData.footer));
            formData.append("AboutUsJson", JSON.stringify(workingData.aboutUs));
            formData.append("ContactUsJson", JSON.stringify(workingData.contactUs));
            formData.append("SeoJson", JSON.stringify(workingData.seo));
            formData.append("DestinationsJson", JSON.stringify({ destinations: workingData.destinations }));

            await apiService.post(config.ASSIGNTEMPLATE, formData);
            toast.success("Theme Published Successfully!");
        } catch (err) {
            toast.error("Error publishing changes.");
        } finally { setIsSaving(false); }
    };

    // ⭐ Logic to resolve the package for the Preview
    const getResolvedPackage = () => {
        // We use the reference from the workingData (database field)
        const ref = workingData.templateReference || workingData.templateRefference;
        let basePackage;

        if (ref === "Template_4") basePackage = { ...mapT4(workingData), colors: getB2CColors_T4(mapT4(workingData)) };
        else if (ref === "Template_2") basePackage = { ...mapT2(workingData), colors: getB2CColors_T2(mapT2(workingData)) };
        else basePackage = { ...mapT1(workingData), colors: getB2CColors_T1(mapT1(workingData)) };

        return {
            ...basePackage,
            headingFont: workingData.theme.headingFont || 'Cormorant Garamond',
            bodyFont:    workingData.theme.bodyFont    || 'Jost'
        };
    };

    // ⭐ Identify the Active Template Component
    const currentRef = workingData.templateReference || workingData.templateRefference;
    const ActiveTemplate = templateMap[currentRef];

    return (
        <div style={{ display: 'flex', height: 'calc(100vh - 60px)', width: '100vw', overflow: 'hidden', background: '#f8f9fa' }}>
            
            {/* ──── LEFT PANEL: EDITOR CONTROLS ──── */}
            <div style={{ 
                width: '400px', background: '#fff', borderRight: '1px solid #ddd', 
                display: 'flex', flexDirection: 'column', zIndex: 10, boxShadow: '4px 0 10px rgba(0,0,0,0.03)' 
            }}>
                <div style={{ padding: '15px 20px', borderBottom: '1px solid #f0f0f0', background: '#fcfcfc' }}>
                    <h6 className="fw-bold m-0 text-primary">Styles & Visuals</h6>
                </div>

                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <Accordion defaultActiveKey="0" flush>
                        
                        {/* 1. GLOBAL COLORS */}
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><i className="ri-palette-line me-2"></i> Global Colors</Accordion.Header>
                            <Accordion.Body>
                                {[1, 2, 3, 4, 5].map(num => (
                                    <div key={num} className="mb-3">
                                        <label className="small fw-bold mb-1">Theme Color {num}</label>
                                        <div className="d-flex gap-2">
                                            <Form.Control type="color" value={workingData.theme[`themeColor${num}`] || '#ffffff'} 
                                                onChange={(e) => updateSection('theme', `themeColor${num}`, e.target.value)}
                                                style={{ width: '40px', height: '40px', padding: '2px' }} />
                                            <Form.Control type="text" value={workingData.theme[`themeColor${num}`] || ''} 
                                                onChange={(e) => updateSection('theme', `themeColor${num}`, e.target.value)} />
                                        </div>
                                    </div>
                                ))}
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* 2. TYPOGRAPHY */}
                        <Accordion.Item eventKey="1">
                            <Accordion.Header><i className="ri-font-size me-2"></i> Typography</Accordion.Header>
                            <Accordion.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small fw-bold">Heading Font</Form.Label>
                                    <Form.Select value={workingData.theme.headingFont || 'Cormorant Garamond'} onChange={(e) => updateSection('theme', 'headingFont', e.target.value)}>
                                        {FONT_OPTIONS.map(f => <option key={f} value={f}>{f}</option>)}
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small fw-bold">Body Font</Form.Label>
                                    <Form.Select value={workingData.theme.bodyFont || 'Jost'} onChange={(e) => updateSection('theme', 'bodyFont', e.target.value)}>
                                        {FONT_OPTIONS.map(f => <option key={f} value={f}>{f}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* 3. TOP BAR */}
                        <Accordion.Item eventKey="2">
                            <Accordion.Header><i className="ri-window-line me-2"></i> Top Bar Settings</Accordion.Header>
                            <Accordion.Body>
                                <label className="small fw-bold mb-1">Background Color</label>
                                <Form.Control type="color" value={workingData.topBar?.bgColor || '#0056A6'} 
                                    onChange={(e) => updateSection('topBar', 'bgColor', e.target.value)} className="mb-3" />
                                <label className="small fw-bold mb-1">Text/Icon Color</label>
                                <Form.Control type="color" value={workingData.topBar?.textColor || '#ffffff'} 
                                    onChange={(e) => updateSection('topBar', 'textColor', e.target.value)} className="mb-3" />
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* 4. HEADER */}
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><i className="ri-layout-top-line me-2"></i> Header Settings</Accordion.Header>
                            <Accordion.Body>
                                <label className="small fw-bold mb-1">Background Color</label>
                                <Form.Control type="color" value={workingData.header?.bgColor || '#ffffff'} 
                                    onChange={(e) => updateSection('header', 'bgColor', e.target.value)} className="mb-3" />
                                <label className="small fw-bold mb-1">Text Color</label>
                                <Form.Control type="color" value={workingData.header?.textColor || '#000000'} 
                                    onChange={(e) => updateSection('header', 'textColor', e.target.value)} className="mb-3" />
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* 5. MODULE HEROS */}
                        {['flights', 'hotels', 'holidays', 'sightseeing'].map((mod, idx) => (
                            <Accordion.Item eventKey={idx + 4} key={mod}>
                                <Accordion.Header><i className="ri-image-line me-2"></i> <span className="text-capitalize">{mod} Hero Settings</span></Accordion.Header>
                                <Accordion.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold">Hero Title</Form.Label>
                                        <Form.Control type="text" value={workingData.hero[mod]?.title || ''} onChange={(e) => updateModuleHero(mod, 'title', e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold">Hero Sub-Title</Form.Label>
                                        <Form.Control as="textarea" rows={2} value={workingData.hero[mod]?.subTitle || ''} onChange={(e) => updateModuleHero(mod, 'subTitle', e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold">Hero Text Color</Form.Label>
                                        <div className="d-flex gap-2">
                                            <Form.Control type="color" value={workingData.hero[mod]?.textColor || '#ffffff'} onChange={(e) => updateModuleHero(mod, 'textColor', e.target.value)} style={{ width: '40px', height: '40px' }} />
                                            <Form.Control type="text" value={workingData.hero[mod]?.textColor || ''} onChange={(e) => updateModuleHero(mod, 'textColor', e.target.value)} />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold">Background Image URL</Form.Label>
                                        <Form.Control type="text" value={workingData.hero[mod]?.bgImage || ''} onChange={(e) => updateModuleHero(mod, 'bgImage', e.target.value)} placeholder="https://..." />
                                    </Form.Group>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}

                        {/* 6. FOOTER */}
                        <Accordion.Item eventKey="9">
                            <Accordion.Header><i className="ri-layout-bottom-line me-2"></i> Footer Settings</Accordion.Header>
                            <Accordion.Body>
                                <label className="small fw-bold mb-1">Background Color</label>
                                <Form.Control type="color" value={workingData.footer?.bgColor || '#1a1a1a'} 
                                    onChange={(e) => updateSection('footer', 'bgColor', e.target.value)} className="mb-3" />
                                <label className="small fw-bold mb-1">Text Color</label>
                                <Form.Control type="color" value={workingData.footer?.textColor || '#ffffff'} 
                                    onChange={(e) => updateSection('footer', 'textColor', e.target.value)} className="mb-3" />
                            </Accordion.Body>
                        </Accordion.Item>

                    </Accordion>
                </div>

                <div style={{ padding: '20px', background: '#fff', borderTop: '1px solid #f0f0f0' }}>
                    <div className="d-flex gap-2">
                        <Button variant="outline-secondary" className="flex-grow-1 fw-bold" onClick={onBack}>← BACK</Button>
                        <Button onClick={handlePublish} disabled={isSaving} variant="primary" className="flex-grow-1 fw-bold">
                            {isSaving ? 'PUBLISHING...' : 'PUBLISH ✦'}
                        </Button>
                    </div>
                </div>
            </div>

            {/* ──── RIGHT PANEL: LIVE PREVIEW ──── */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#eee', overflow: 'hidden' }}>
                <div style={{ background: '#fff', borderBottom: '1px solid #ddd', padding: '10px 20px', zIndex: 100 }}>
                    <Nav variant="pills" activeKey={activeView} onSelect={(k) => setActiveView(k)} className="justify-content-center">
                        <Nav.Item><Nav.Link eventKey="flights" className="small fw-bold px-3">Flights</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link eventKey="hotels" className="small fw-bold px-3">Hotels</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link eventKey="holidays" className="small fw-bold px-3">Holidays</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link eventKey="sightseeing" className="small fw-bold px-3">Sightseeing</Nav.Link></Nav.Item>
                    </Nav>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
                    <div style={{ 
                        position: 'sticky', top: 0, background: '#ffc107', color: '#000', 
                        padding: '6px', fontSize: '11px', fontWeight: 800, textAlign: 'center', zIndex: 100,
                        textTransform: 'uppercase', letterSpacing: '1px'
                    }}>
                        <i className="ri-flashlight-line me-1"></i> Real-time Preview Mode
                    </div>

                    <LandingContext.Provider value={getResolvedPackage()}>
                        {/* Dynamic Font Loader */}
                        <link rel="stylesheet" href={`https://fonts.googleapis.com/css2?family=${workingData.theme.headingFont?.replace(/ /g, '+')}&family=${workingData.theme.bodyFont?.replace(/ /g, '+')}&display=swap`} />
                        
                        <div className="preview-scope" style={{ 
                            pointerEvents: 'none', userSelect: 'none',
                            '--heading-font': workingData.theme.headingFont,
                            '--body-font': workingData.theme.bodyFont
                        }}>
                            <style>{`
                                .preview-scope h1, .preview-scope h2, .preview-scope h3, .preview-scope .section-title, .preview-scope .hero-heading {
                                    font-family: "${workingData.theme.headingFont}", serif !important;
                                }
                                .preview-scope, .preview-scope p, .preview-scope button, .preview-scope input, .preview-scope span, .preview-scope a {
                                    font-family: "${workingData.theme.bodyFont}", sans-serif !important;
                                }
                            `}</style>
                            <Suspense fallback={<div className="p-5 text-center">Loading Preview...</div>}>
                                {/* ⭐ FIX: Ensure ActiveTemplate is rendering based on workingData.templateReference */}
                                {ActiveTemplate ? (
                                    <ActiveTemplate isPreview={true} activeView={activeView} />
                                ) : (
                                    <div className="p-5 text-center">Template {currentRef} could not be loaded.</div>
                                )}
                            </Suspense>
                        </div>
                    </LandingContext.Provider>
                </div>
            </div>
        </div>
    );
};

export default WebsiteVisualizer;